
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/copiercosts/contact-us",
      function () {
        return require("private-next-pages/copiercosts/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/copiercosts/contact-us"])
      });
    }
  